

























import { defineComponent, toRefs, PropType, ref, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  BEHAVIOR_TARGETING_SCENES_TYPE,
  CampaignFormData,
  CREATOR_ACTIONS,
  VIDEO_ACTIONS,
  BEHAVIOR_DAYS,
} from '@tt4b/ttam-enums';
import { getCurrentLang } from '@tt4b/ttam-utils';
import RecommendInterestBehavior from './index';
import { RecommendTargetDataWithLabel } from './types';
import { cloneDeep } from 'lodash-es';
import { flattenRecommendTargetData } from './utils';

const name = 'ttam-recommend-interest-behavior-compose';
export default defineComponent({
  name,
  components: {
    TtamRecommendInterestBehaviorSummary: RecommendInterestBehavior.TtamRecommendInterestBehaviorSummary,
    TtamRecommendInterestBehaviorMoreDialog: RecommendInterestBehavior.TtamRecommendInterestBehaviorMoreDialog,
    TtamRecommendInterestBehaviorApplyBtn: RecommendInterestBehavior.TtamRecommendInterestBehaviorApplyBtn,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);

    const { data: recommendData } = RecommendInterestBehavior.useRecommendTargetDataSource({
      adgroupData,
      campaignData,
    });

    const { updateTraceInfo } = RecommendInterestBehavior.useRecommendTargetTrack({
      adgroupData,
      campaignData,
    });

    const moreDialogVisible = ref(false);

    const disableBtn = computed(() => !flattenRecommendTargetData(recommendData.value)?.length);

    function onOpenDialog() {
      moreDialogVisible.value = true;
    }

    function onCloseDialog() {
      moreDialogVisible.value = false;
    }

    function onApply(source, data?: RecommendTargetDataWithLabel) {
      let temp: Partial<AdgroupFormData> = {};
      const needUnfoldBlock: string[] = [];
      let recommend = data ?? recommendData.value;
      const { actionScenesV2, videoActionsV2, actionCategoriesV2, actionDaysV2 } = cloneDeep(adgroupData.value);
      const interest = (recommend?.interest ?? [])?.map(o => o.value);
      const videoRelatedIds = (recommend?.behavior?.video ?? []).map(o => o.value);
      const creatorRelatedIds = (recommend?.behavior?.creator ?? []).map(o => o.value);
      const interestKeywords = (recommend?.interestKeywords ?? []).map(o => o.value);
      if (interest.length || interestKeywords.length) {
        temp.adTagV2 = interest;

        temp.interestKeywordsI18n = interestKeywords;
        temp.interestKeywordsLangI18n = new Array(interestKeywords.length).fill(getCurrentLang());

        needUnfoldBlock.push('interest');
      }

      if (videoRelatedIds?.length) {
        let index = actionScenesV2.indexOf(BEHAVIOR_TARGETING_SCENES_TYPE.video);
        index = index > -1 ? index : actionScenesV2.length;
        actionScenesV2[index] = BEHAVIOR_TARGETING_SCENES_TYPE.video;
        videoActionsV2[index] = VIDEO_ACTIONS().map(item => item.value);
        actionCategoriesV2[index] = videoRelatedIds;
        actionDaysV2[index] = BEHAVIOR_DAYS.IN_15_DAY.id;
        needUnfoldBlock.push('video');
      }

      if (creatorRelatedIds?.length) {
        let index = actionScenesV2.indexOf(BEHAVIOR_TARGETING_SCENES_TYPE.creator);
        index = index > -1 ? index : actionScenesV2.length;
        actionScenesV2[index] = BEHAVIOR_TARGETING_SCENES_TYPE.creator;
        videoActionsV2[index] = CREATOR_ACTIONS().map(item => item.value);
        actionCategoriesV2[index] = creatorRelatedIds;
        actionDaysV2[index] = BEHAVIOR_DAYS.NONE.id;
        needUnfoldBlock.push('creator');
      }
      temp = { ...temp, actionScenesV2, videoActionsV2, actionCategoriesV2, actionDaysV2 };

      updateTraceInfo(source);

      emit('apply', temp, recommend, source);
      emit('unfold', needUnfoldBlock);
    }

    return {
      name,
      moreDialogVisible,
      recommendData,
      disableBtn,
      onOpenDialog,
      onCloseDialog,
      onApply,
    };
  },
});
